import React from 'react'
import { NO_NONE_NOPES, NO_NONE_NOPE_FIELD_DATA } from '../camperConstants'

const withEventHandlers = WrappedComponent => {
  return props => {
    const {
      setCamperFormField,
      updateArrayField,
      setFormErrors,
      setSelectedGradeId // via withState
    } = props

    const handleChangeArrayField = (fieldName, option) => event =>
      updateArrayField(fieldName, option, event.target.checked)

    const fieldInNoNopeFields = (fieldName) => {
      return Object.keys(NO_NONE_NOPE_FIELD_DATA).includes(fieldName)
    }

    const handleChangeCamperFormField = fieldName => event => {
      if (fieldInNoNopeFields(fieldName) && NO_NONE_NOPES.includes(event.target.value.toLowerCase().trim())) {
        setFormErrors({[fieldName]: `If there are no other ${NO_NONE_NOPE_FIELD_DATA[fieldName]}, please leave blank`})
      } else {
        setFormErrors({[fieldName]: ''})
      }

      setCamperFormField(fieldName, event.target.value)
    }

    const handleChangeDateField = (fieldName, value) =>
      setCamperFormField(fieldName, value)

    // Radio value is cast to string by DOM API.
    // Cast it back to a boolean.
    const handleChangeBooleanStringField = fieldName => event => {
      const values = {
        true: true,
        false: false,
        '': null
      }
      setCamperFormField(fieldName, values[event.target.value])
    }

    return (
      <WrappedComponent
        onChangeArrayField={handleChangeArrayField}
        onChangeBooleanStringField={handleChangeBooleanStringField}
        onChangeCamperFormField={handleChangeCamperFormField}
        onChangeDateField={handleChangeDateField}
        {...props}
      />
    )
  }
}

export default withEventHandlers
